export default function (instance) {
    return {
        auth(payload){
            return instance.postForm('sms-login', payload)
        },
        authV2(payload){
            return instance.postForm('auth', payload)
        },
        checkSession(payload){
            return instance.postForm('auth/check-session', payload)
        },
        checkAuthCallGate(payload){
            return instance.postForm('user/check-login-phone', payload)
        },
        registration(payload){
            return instance.postForm('user', payload)
        },
    }
}